import { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MetaTags from '../components/MetaTags';
import api from '../api/axios';
import './new-pages.css';

export default function FeedbackPage() {
  const [site, setSite] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch('/content.json')
      .then(r => r.json())
      .then(d => { setSite(d.site); setPageLoading(false); })
      .catch(() => setPageLoading(false));
  }, []);

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true); setError('');
    try {
      await api.post('/feedback', form);
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send. Please try again.');
    } finally {
      setSending(false);
    }
  };

  if (pageLoading) return <div className="page-loading"><div className="spinner-ring"></div></div>;
  if (!site) return null;

  return (
    <div className="App">
      <MetaTags
        title="Contact | Melbourne Nepalese Community West"
        description="Get in touch with MNCW. Send us your questions, suggestions, or feedback."
        url="https://mncw.org.au/feedback"
        image="https://mncw.org.au/assets/img/logo.jpg"
        type="website"
      />
      <Header data={site} />

      <div className="feedback-page-container">
        <div className="container">
          <div className="page-header" style={{ marginBottom: 48 }}>
            <span className="page-subtitle">Get In Touch</span>
            <h1>Contact Us</h1>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: 48, alignItems: 'start' }}>
            {/* Contact info */}
            <div className="contact-info">
              <h2 style={{ color: 'var(--dark-blue)', marginBottom: 16 }}>We'd Love to Hear From You</h2>
              <p className="lead">Have a question, suggestion, or concern? Send us a message and we'll get back to you as soon as possible.</p>

              <div className="contact-detail">
                <div className="icon"><i className="fas fa-map-marker-alt"></i></div>
                <div className="text">68 Clara Avenue, Trugaina, 3029 VIC</div>
              </div>
              <div className="contact-detail">
                <div className="icon"><i className="fas fa-envelope"></i></div>
                <div className="text">
                  <a href={`mailto:${site.email || 'mncwestv@gmail.com'}`} style={{ color: 'var(--text-dark)', textDecoration: 'none' }}>
                    {site.email || 'mncwestv@gmail.com'}
                  </a>
                </div>
              </div>
              {site.facebookUrl && (
                <div className="contact-detail">
                  <div className="icon"><i className="fab fa-facebook-f"></i></div>
                  <div className="text">
                    <a href={site.facebookUrl} target="_blank" rel="noreferrer" style={{ color: 'var(--primary-blue)', textDecoration: 'none' }}>
                      Follow us on Facebook
                    </a>
                  </div>
                </div>
              )}
            </div>

            {/* Form */}
            <div className="contact-form-card">
              {sent ? (
                <div style={{ textAlign: 'center', padding: '40px 0' }}>
                  <i className="fas fa-check-circle" style={{ fontSize: '3.5rem', color: 'green', display: 'block', marginBottom: 16 }}></i>
                  <h3 style={{ color: 'var(--dark-blue)', marginBottom: 8 }}>Message Sent!</h3>
                  <p style={{ color: 'var(--text-light)', marginBottom: 24 }}>Thank you for reaching out. We'll get back to you soon.</p>
                  <button className="btn-mncw btn-mncw-outline" onClick={() => { setSent(false); setForm({ name: '', email: '', subject: '', message: '' }); }}>
                    Send Another Message
                  </button>
                </div>
              ) : (
                <form onSubmit={submit}>
                  {error && (
                    <div style={{ background: '#fff3f3', border: '1px solid #ffcccc', borderRadius: 8, padding: '12px 16px', marginBottom: 20, color: 'var(--primary-red)', fontSize: '0.9rem' }}>
                      {error}
                    </div>
                  )}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                    <div className="mncw-form-group">
                      <label className="mncw-label">Your Name *</label>
                      <input name="name" value={form.name} onChange={handle} required className="mncw-input" placeholder="Full name" />
                    </div>
                    <div className="mncw-form-group">
                      <label className="mncw-label">Email Address *</label>
                      <input name="email" value={form.email} onChange={handle} required type="email" className="mncw-input" placeholder="you@email.com" />
                    </div>
                  </div>
                  <div className="mncw-form-group">
                    <label className="mncw-label">Subject *</label>
                    <input name="subject" value={form.subject} onChange={handle} required className="mncw-input" placeholder="What is this about?" />
                  </div>
                  <div className="mncw-form-group">
                    <label className="mncw-label">Message *</label>
                    <textarea name="message" value={form.message} onChange={handle} required rows="5" className="mncw-input" placeholder="Your message here..." style={{ resize: 'vertical', minHeight: 120 }}></textarea>
                  </div>
                  <button type="submit" disabled={sending} className="btn-mncw" style={{ width: '100%', justifyContent: 'center' }}>
                    {sending ? <><i className="fas fa-spinner fa-spin"></i> Sending…</> : <><i className="fas fa-paper-plane"></i> Send Message</>}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer data={site} />
    </div>
  );
}
